var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"mouseover":function($event){return _vm.enter()},"mouseleave":function($event){return _vm.leave()}}},[(_vm.active)?_c('span',[_vm._t("active_slot")],2):_c('span',[_vm._t("inactive_slot")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }